module.exports = true;



//////////////////
// WEBPACK FOOTER
// ./~/_core-js@2.6.0@core-js/library/modules/_library.js
// module id = 23
// module chunks = 0